<template>
  <div class="panel panel-default">
    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row tw-mb-6">
        <div class="col-xs-offset-18 col-xs-6">
          <SelectWidget
              v-model="location"
              :options="locationOptions"
              :nullable="true"
              placeholder="(all locations)"
          />
        </div>
      </div>

      <table class="capacity publication-capacity">
        <thead>
        <tr>
          <td class="capacity__first-cell"></td>

          <td v-for="publication in capacity.data.publications" :key="publication.id" class="capacity__head-cell">
                            <span class="capacity__head-inner-cell">
                                <div class="capacity__headline">
                                    <router-link :to="'/publications/' + publication.id">
                                        {{ publication.name }}
                                    </router-link>
                                </div>
                            </span>
          </td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="row in filteredRows" :key="row.id" is="publication-capacity-row" :row="row"></tr>
        </tbody>
      </table>

      <pager
          :previous-id="capacity.data.previous"
          :next-id="capacity.data.next"
          @navigate="from = $event"
      ></pager>
    </div>
  </div>
</template>

<script>
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Pager from '@/components/Panels/Publications/PublicationBasedChannelCapacityPanel/Pager'
import PublicationCapacityRow
  from '@/components/Panels/Publications/PublicationBasedChannelCapacityPanel/PublicationCapacityRow'
import SaveHeight from '@/mixins/SaveHeight'
import SelectWidget from "../../../../vendor/forms/FormGroups/Widgets/Select";

export default {
  components: {LoadingSpinner, Pager, PublicationCapacityRow,SelectWidget},

  mixins: [Load, SaveHeight],

  props: ['channelId', 'channelType'],

  data() {
    return {
      capacity: null,
      from: this.getQueryParam('from', ''),

      location: null,
    }
  },

  watch: {
    channelId() {
      this.from = ''

      this.fetch()
    },

    from(value) {
      this.fetch()

      this.$router.push(
          '/capacity?channel-id=' + this.channelId + '&channel-type=' + this.channelType + '&from=' + value
      )
    }
  },

  mounted() {
    this.fetch()
  },

  computed: {
    locationOptions() {
      return Object.entries(this.capacity.data.rows.reduce((result, row) => {
        result[row.location.id] = row.location.name

        return result
      }, {})).map(entry => ({value: entry[0], label: entry[1]}))
    },

    filteredRows() {
      return this.capacity.data.rows
          .filter(row => !this.location || row.location.id.toString() === this.location)
    },
  },

  methods: {
    fetch() {
      this.saveHeight()

      this.load({
        capacity: '/api/v1/publication-based-channels/' + this.channelId + '/capacity?from=' + this.from
      })
    },

    getQueryParam(key, defaultValue = null) {
      return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
    }
  }
}
</script>
